// Generated by unitfield-landing/scripts/sync-legal-revisions.mjs. Do not edit by hand.
export const UNITFIELD_LEGAL_ORIGIN = 'https://unitfield.com';
export const UNITFIELD_LEGAL_DOCUMENTS = {
  "b2bTerms": {
    "id": "unitfield-b2b-terms",
    "version": "2026-11-01",
    "contentSha256": "94bbdadac84b2be3df32fbb6520c7b9728c6c29b8af06ded23ef7e88fd1030bf",
    "effectiveDate": "November 1, 2026",
    "href": "/terms"
  },
  "privacy": {
    "id": "unitfield-privacy-notice",
    "version": "2026-11-01",
    "contentSha256": "58c359bd7e44e8984d3c56e6405882130fad628359668afd5e020d7e2b053a6e",
    "effectiveDate": "November 1, 2026",
    "href": "/privacy"
  },
  "applicantPrivacy": {
    "id": "unitfield-applicant-privacy-notice",
    "version": "2026-10-21",
    "contentSha256": "9261ae9090ad8c3c2952be6c96176f289a095c713b82caf68ca5c465de05d2ec",
    "effectiveDate": "October 21, 2026",
    "href": "/legal/applicant-privacy"
  },
  "rentalApplicationTerms": {
    "id": "unitfield-rental-application-terms",
    "version": "2026-10-20",
    "contentSha256": "22faede781c2570b8ed6eb153fe060a1a5acaf0020a97d5fa61f7fb60317868b",
    "effectiveDate": "October 20, 2026",
    "href": "/legal/rental-application-terms"
  },
  "electronicRecords": {
    "id": "unitfield-electronic-records-consent",
    "version": "2026-10-20",
    "contentSha256": "5e5bd36fa229fe2d11a48ca370d5a1e1e46f953301d20b097aced17e737af4c5",
    "effectiveDate": "October 20, 2026",
    "href": "/legal/electronic-records-consent"
  },
  "residentPortalTerms": {
    "id": "unitfield-resident-portal-terms",
    "version": "2026-10-21",
    "contentSha256": "e34621c0518fa6836b13ea870546ff4b6dea5a7817dc180f4b4e1d8221b4f0f2",
    "effectiveDate": "October 21, 2026",
    "href": "/legal/resident-portal-terms"
  },
  "residentPrivacy": {
    "id": "unitfield-resident-privacy-notice",
    "version": "2026-11-01",
    "contentSha256": "4235ba736954650d30d5958b4f4b6b311047e1591b707dee02eb3b2dabf05315",
    "effectiveDate": "November 1, 2026",
    "href": "/legal/resident-privacy"
  },
  "residentAutoPayAuthorization": {
    "id": "unitfield-resident-autopay-authorization",
    "version": "2026-10-20",
    "contentSha256": "b306b6ce9e0658268ad88ab63b44aa9370c89ec27502b754d9104846d33c6d39",
    "effectiveDate": "October 20, 2026",
    "href": "/legal/resident-autopay-authorization"
  },
  "cookieNotice": {
    "id": "unitfield-cookie-notice",
    "version": "2026-10-20",
    "contentSha256": "4f7e263de64775cab04c5cb5422836e01b2d4dab5d4c6b5b0fba21ca33d3fa51",
    "effectiveDate": "October 20, 2026",
    "href": "/cookies"
  },
  "dpa": {
    "id": "unitfield-data-processing-addendum",
    "version": "2026-11-01",
    "contentSha256": "f0ef0c36b652fed57fdd547e397dc8221a6ba8a94e317250c7d0408301a70410",
    "effectiveDate": "November 1, 2026",
    "href": "/dpa"
  },
  "subprocessors": {
    "id": "unitfield-subprocessors",
    "version": "2026-11-01",
    "contentSha256": "43c02cd92203f04add86b4df57a7337c1ba9368f2b7b7fa0d0ccff1658c778cb",
    "effectiveDate": "November 1, 2026",
    "href": "/subprocessors"
  },
  "textMessaging": {
    "id": "unitfield-text-messaging-terms",
    "version": "2026-10-21",
    "contentSha256": "8a95183404d9f6e09b35fb183fda0d9ed8ddf02b7f3ae8579d83fdd7e247897e",
    "effectiveDate": "October 21, 2026",
    "href": "/legal/text-messaging"
  }
} as const;

export type UnitfieldLegalDocumentKey = keyof typeof UNITFIELD_LEGAL_DOCUMENTS;

export function unitfieldLegalUrl(key: UnitfieldLegalDocumentKey): string {
  return UNITFIELD_LEGAL_ORIGIN + UNITFIELD_LEGAL_DOCUMENTS[key].href;
}

// Manifest-bound API URLs remain separate evidence endpoints, including the recurring runtime alias.
